import * as React from 'react';

import { UIHelper } from '../utils/UIHelper';

interface ClickButtonState {
    active: boolean;
}

interface ClickButtonProps {
    callback: () => void;
    active?: boolean;
    className: string;
    noAnimate?: boolean;
    disabled?: boolean;
}

export class ClickButton extends React.Component<ClickButtonProps, ClickButtonState> {
    protected domElement: HTMLDivElement;

    public componentWillMount(): void {
        this.setState({
            active: false
        });
    }

    public render(): JSX.Element {
        const cssClass: string = this.props.className;
        return (
            <div
                className={cssClass + (this.props.active ? ' active-button' : '') + (this.props.disabled ? ' disabled' : '')}
                onClick={this.onClick}
                ref={(node: HTMLDivElement) => {this.domElement = node; }}
            >
                {this.props.children}
            </div>
        );
    }

    protected onClick = (event: React.MouseEvent): void => {
        if (!this.props.disabled) {
            UIHelper.stopEvent(event);
            this.props.callback();
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ClickButton.tsx